import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { upperFirst } from 'lodash';

import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnName = ({ name, nip }) => {
  const { t } = useTranslation('user');
  return (
    <Box className={styles['column-name__container']}>
      <TextRegular className={styles['column-name__text--name']}>{upperFirst(name)}</TextRegular>
      <TextRegular className={styles['column-name__text--nip']}>{t('idFormat', { nip })}</TextRegular>
    </Box>
  );
};

export default ColumnName;